import React, { Component } from 'react';
import perfectScrollBar from 'perfect-scrollbar';
import { PerfectScrollbarGlobalStyles } from './PerfectScrollbarGlobalStyles';

const DEFAULT_SCROLL_OPTIONS = {
  wheelSpeed: 1,
  wheelPropagation: false,
  minScrollbarLength: 20,
};

interface ScrollContainerOwnProps {
  className?: string;
  options: {
    useKeyboard?: boolean;
    suppressScrollY?: boolean;
    suppressScrollX?: boolean;
    wheelPropagation?: boolean;
    swipePropagation?: boolean;
    useBothWheelAxes?: boolean;
    wheelSpeed?: number;
    minScrollbarLength?: number;
    maxScrollbarLength?: number;
    scrollXMarginOffset?: number;
    scrollYMarginOffset?: number;
  };
}

class ScrollContainer extends Component<React.PropsWithChildren<ScrollContainerOwnProps>> {
  static defaultProps = {
    className: null,
    options: DEFAULT_SCROLL_OPTIONS,
  };

  state = { isActive: false };

  element = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.activateScrollBar(this.element);
  }

  componentDidUpdate() {
    this.activateScrollBar(this.element);
  }

  activateScrollBar(element: React.RefObject<HTMLDivElement>) {
    const { options } = this.props;
    const { isActive } = this.state;

    if (!element.current) {
      return this.setState({ isActive: false });
    }

    if (isActive) {
      return perfectScrollBar.update(element.current);
    }

    perfectScrollBar.initialize(element.current, Object.assign({}, DEFAULT_SCROLL_OPTIONS, options));
    return this.setState({ isActive: true });
  }

  render() {
    return (
      <>
        <PerfectScrollbarGlobalStyles />
        <div className={this.props.className} ref={this.element}>
          {this.props.children}
        </div>
      </>
    );
  }
}

export default ScrollContainer;
